module.exports = "https://cdn.thelire.com/ins/resource/coin_store_title_icon.2531780b21e0f875e4811e320aa137f7.png";